import styled from 'styled-components'

export const Div = styled.div`
  flex: 1 0 auto;
  width: 55%;

  & .hot-button {
    align-self: flex-start;
  }
`

Div.displayName = 'DIVLiveHighLight'

export const H2 = styled.h2`
  font-size: 1.125rem;
  line-height: 1.17;
  font-weight: 800;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow-wrap: break-word;
`

H2.displayName = 'H2LiveHighLight'

export const P = styled.p`
  line-height: 1.5;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow-wrap: break-word;
`

P.displayName = 'PLiveHighLight'

export const Picture = styled.picture`
  background-color: #f4f7f8;
  flex: 1 0 auto;
  width: 45%;
  max-width: 30rem;

  > img:not(.brand) {
    aspect-ratio: 16/9;
    width: 100%;
    max-width: 100%;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .brand {
    right: 0.5rem;
    bottom: 0.5rem;
  }
`

Picture.displayName = 'PictureLiveHighLight'

export const LiveHighLightContainer = styled.div`
  max-height: 16.25rem;
`

LiveHighLightContainer.displayName = 'LiveHighLightContainer'
